import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-upload-sender',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './upload-sender.component.html',
  styleUrl: './upload-sender.component.scss',
})
export class UploadSenderComponent {}
